require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./granit-arbeitsplatte.json") })
        }
      }, "path---granit-arbeitsplatte");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---granit-arbeitsplatte!./.cache/json/granit-arbeitsplatte.json
// module id = 450
// module chunks = 231608221292675